export default __webpack_public_path__ + "static/media/fol_tone.7f3887cf.png";